document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', (event) => {
    const target = event.target;
    
    // Check if the change happened inside Prestige's variant picker
    if (target && (target.name === 'id' || target.closest('variant-picker') || target.closest('[data-block-type="variant_picker"]'))) {
      
      const selectedInput = document.querySelector('form[action*="/cart/add"] input[name="id"]') || target;
      const newVariantId = selectedInput ? selectedInput.value : target.value;

      if (!newVariantId) return;

      const currentUrl = new URL(window.location.href);
      const currentVariantId = currentUrl.searchParams.get('variant');

      // If switching variants, append the loading spinner next to the price
      if (newVariantId !== currentVariantId) {
        const priceBlock = document.querySelector('[data-block-type="price"]') || document.querySelector('.price-list');
        
        if (priceBlock && !priceBlock.querySelector('.price-loading-badge')) {
          const loadingBadge = document.createElement('span');
          loadingBadge.className = 'price-loading-badge';
          loadingBadge.innerHTML = '<span class="price-loading-spinner"></span> Updating price...';
          
          priceBlock.appendChild(loadingBadge);
        }

        currentUrl.searchParams.set('variant', newVariantId);
        window.location.href = currentUrl.toString();
      }
    }
  });
});